export default __webpack_public_path__ + "static/33-0cd4536df7aba07954561d4de05a7d74.png";